import API from './API';
import { authEndpoints } from './API.constants';
import type {
  CompleteResetPasswordRequest,
  CompleteResetPasswordResponse,
  RequestResetLinkRequest,
  ValidateResetLinkRequest,
  ValidateResetLinkResponse,
} from './forgot-password.types';

export const requestResetLink = async (
  body: RequestResetLinkRequest,
): Promise<void> => {
  await API.post(authEndpoints.passwordResetRequest, body);
};

export const validateResetLink = async (
  body: ValidateResetLinkRequest,
): Promise<ValidateResetLinkResponse> =>
  (
    await API.post<ValidateResetLinkResponse>(
      authEndpoints.passwordResetValidate,
      body,
    )
  ).data;

export const completeResetPassword = async (
  body: CompleteResetPasswordRequest,
): Promise<CompleteResetPasswordResponse> =>
  (
    await API.post<CompleteResetPasswordResponse>(
      authEndpoints.passwordResetComplete,
      body,
    )
  ).data;
